import logo from './logo.svg';
import './App.css';
import Foodrecipe from './Component/Foodrecipe';

function App() {
  return (
    <div className="App">
       <Foodrecipe></Foodrecipe>
    </div>
  );
}

export default App;
